import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../../config';
import { deleteMasterFieldMapping } from '../../../function/handleMasterVerification';
import { getMasterMappingsByPatternId } from './read';

export const deleteMasterMapping = async (masterId: string, mappingId: string): Promise<void> => {
  const mappingRef = doc(db, 'masters', masterId, 'master_mappings', mappingId);
  await deleteDoc(mappingRef);
};

/**
 * 指定パターンに紐づくマスタのマッピングを全て物理削除する（#3056）。
 * パターン削除時に、そのパターンで設定されていたマスタ照合マッピングも一緒に消す。
 * Firestore の master_mappings と Cloud SQL の master_field_mappings の両方を削除する
 * （単体削除 handleDeleteMapping と同じ流儀）。
 * マッピングが 1 件も無ければ何もしない。
 */
export const deleteMasterMappingsByPatternId = async (
  companyId: string,
  patternId: string,
): Promise<void> => {
  const mappings = await getMasterMappingsByPatternId(companyId, patternId);
  if (mappings.length === 0) return;

  for (const mapping of mappings) {
    // Firestore の master_mappings を物理削除
    await deleteMasterMapping(mapping.master_id, mapping.mapping_id);
    // Cloud SQL の master_field_mappings も削除（source_field_name = search_item_label）
    if (mapping.pattern_id && mapping.search_item_label) {
      await deleteMasterFieldMapping({
        gendrive_company_id: companyId,
        pattern_id: mapping.pattern_id,
        source_field_name: mapping.search_item_label,
      });
    }
  }
};
